import clsx from 'clsx';
import React from 'react';
import { TBlogModuleInfoCallout } from '../../blog/blog.types';

import './BlogArticleModuleInfoCallout.scss';

type Props = {
  module: TBlogModuleInfoCallout;
  mobile?: boolean;
};

export const BlogArticleModuleInfoCallout: React.FC<Props> = ({
  module: { content, backgroundColor },
  mobile,
}) => (
  <div
    className={clsx('BlogArticleModuleInfoCallout', {
      'BlogArticleModuleInfoCallout--desktop': !mobile,
      'BlogArticleModuleInfoCallout--mobile': mobile,
    })}

    dangerouslySetInnerHTML={{ __html: content }}

    style={{ backgroundColor }}
  />
);
